// extracted by mini-css-extract-plugin
module.exports = {"Square":"Square_Square__3tJvT","AvoidClicks":"Square_AvoidClicks__MO-xe"};